import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  DatePeriodSerializer_getInstance41w3hzzadrlu as DatePeriodSerializer_getInstance,
  DateTimePeriodSerializer_getInstance1njysvzzhpdqj as DateTimePeriodSerializer_getInstance,
} from './serializers/DateTimePeriodSerializers.mjs';
import { DateTimeFormatException2onfeknbywaob as DateTimeFormatException } from './Exceptions.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  add2suhfggl4zvkk as add,
  convertToInty04h231mmjoh as convertToInt,
  multiply2k9eolhnz1bjv as multiply,
  dividelr0uqtdj497z as divide,
  modulooi4g1kq3dmtt as modulo,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber } from '../../../kotlin-kotlin-stdlib/kotlin/js/rangeTo.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { ClosedRangehokgr73im9z3 as ClosedRange } from '../../../kotlin-kotlin-stdlib/kotlin/ranges/Range.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { contains2c50nlxg7en7o as contains } from '../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { charCodeAt1yspne1d8erbm as charCodeAt } from '../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx,
  toString1n9qg6fb0b5i8 as toString,
  Char__minus_impl_a2frrhw2puetaduxyd as Char__minus_impl_a2frrh,
} from '../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  safeMultiply1xb0xo3cufzd3 as safeMultiply,
  safeAdd2ojtf0puot5k0 as safeAdd,
} from './internal/mathNative.mjs';
import {
  ArithmeticException18dajwq7kbp38 as ArithmeticException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { uppercaseChar6lahngw3wvwg as uppercaseChar } from '../../../kotlin-kotlin-stdlib/kotlin/text/charJs.mjs';
import { substringiqarkczpya5m as substring } from '../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { repeat2w4c6j8zoq09o as repeat } from '../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { toInt5qdj874w69jh as toInt } from '../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  getBigIntHashCode294hi5bdhtj6e as getBigIntHashCode,
  toString1pkumu07cwy4m as toString_0,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { abs1kdzbjes1idip as abs } from '../../../kotlin-kotlin-stdlib/kotlin/math/math.mjs';
import { padStart36w1507hs626a as padStart } from '../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { multiplyAndAdd2gfolze8k1tuw as multiplyAndAdd } from './internal/math.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var DatePeriodClass;
function DatePeriod() {
  if (DatePeriodClass === VOID) {
    class $ extends DateTimePeriod() {
      constructor(totalMonths, days) {
        return new.target.new_kotlinx_datetime_DatePeriod_qtu8pv_k$(totalMonths, days);
      }
      static new_kotlinx_datetime_DatePeriod_qtu8pv_k$(totalMonths, days) {
        var $this = this.new_kotlinx_datetime_DateTimePeriod_hjog9l_k$();
        $this.totalMonths_1 = totalMonths;
        $this.days_1 = days;
        return $this;
      }
      get_totalMonths_xmlea9_k$() {
        return this.totalMonths_1;
      }
      get_days_wokl28_k$() {
        return this.days_1;
      }
      static new_kotlinx_datetime_DatePeriod_19p8ip_k$(years, months, days) {
        years = years === VOID ? 0 : years;
        months = months === VOID ? 0 : months;
        days = days === VOID ? 0 : days;
        return this.new_kotlinx_datetime_DatePeriod_qtu8pv_k$(totalMonths(years, months), days);
      }
      get_hours_islejq_k$() {
        return 0;
      }
      get_minutes_ivkhkm_k$() {
        return 0;
      }
      get_seconds_xuhyfq_k$() {
        return 0;
      }
      get_nanoseconds_3zfxge_k$() {
        return 0;
      }
      get_totalNanoseconds_kpeleb_k$() {
        return 0n;
      }
    }
    initMetadataForClass($, 'DatePeriod', $.new_kotlinx_datetime_DatePeriod_19p8ip_k$, VOID, VOID, VOID, VOID, {0: DatePeriodSerializer_getInstance});
    DatePeriodClass = $;
  }
  return DatePeriodClass;
}
function allNonpositive($this) {
  return $this.get_totalMonths_xmlea9_k$() <= 0n && $this.get_days_wokl28_k$() <= 0 && $this.get_totalNanoseconds_kpeleb_k$() <= 0n && (!(($this.get_totalMonths_xmlea9_k$() | $this.get_totalNanoseconds_kpeleb_k$()) === 0n) || !($this.get_days_wokl28_k$() === 0));
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      parse_pc1q8p_k$(text) {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.datetime.Companion.parseImpl' call
          var START = 0;
          var AFTER_P = 1;
          var AFTER_YEAR = 2;
          var AFTER_MONTH = 3;
          var AFTER_WEEK = 4;
          var AFTER_DAY = 5;
          var AFTER_T = 6;
          var AFTER_HOUR = 7;
          var AFTER_MINUTE = 8;
          var AFTER_SECOND_AND_NANO = 9;
          var state = START;
          var i = 0;
          var sign = 1;
          var years = 0;
          var months = 0;
          var weeks = 0;
          var days = 0;
          var hours = 0;
          var minutes = 0;
          var seconds = 0;
          var nanoseconds = 0;
          var someComponentParsed = false;
          $l$loop_0: while (true) {
            if (i >= text.length) {
              if (state === START) {
                var tmp0 = "Unexpected end of input; 'P' designator is required";
                var position = i;
                throw DateTimeFormatException().new_kotlinx_datetime_DateTimeFormatException_hir7ye_k$('Parse error at char ' + position + ': ' + tmp0);
              }
              if (state === AFTER_T) {
                var tmp0_0 = "Unexpected end of input; at least one time component is required after 'T'";
                var position_0 = i;
                throw DateTimeFormatException().new_kotlinx_datetime_DateTimeFormatException_hir7ye_k$('Parse error at char ' + position_0 + ': ' + tmp0_0);
              }
              var tmp0_1 = fromInt(days);
              // Inline function 'kotlin.Long.plus' call
              var other = imul(weeks, 7);
              var n = add(tmp0_1, fromInt(other));
              var tmp;
              // Inline function 'kotlin.ranges.contains' call
              var this_0 = numberRangeToNumber(-2147483648, 2147483647);
              if (contains(isInterface(this_0, ClosedRange()) ? this_0 : THROW_CCE(), n)) {
                tmp = convertToInt(n);
              } else {
                var message = "The total number of days under 'D' and 'W' designators should fit into an Int";
                throw DateTimeFormatException().new_kotlinx_datetime_DateTimeFormatException_hir7ye_k$('Parse error at char ' + 0 + ': ' + message);
              }
              var daysTotal = tmp;
              if (!someComponentParsed) {
                var message_0 = 'At least one component is required, but none were found';
                throw DateTimeFormatException().new_kotlinx_datetime_DateTimeFormatException_hir7ye_k$('Parse error at char ' + 0 + ': ' + message_0);
              }
              var tmp0_2 = years;
              var tmp2 = months;
              var tmp6 = hours;
              var tmp8 = minutes;
              var tmp10 = seconds;
              var p6 = fromInt(nanoseconds);
              tmp$ret$0 = DateTimePeriod_0(tmp0_2, tmp2, daysTotal, tmp6, tmp8, tmp10, p6);
              break $l$block;
            }
            if (state === START) {
              if ((i + 1 | 0) >= text.length && (charCodeAt(text, i) === _Char___init__impl__6a9atx(43) || charCodeAt(text, i) === _Char___init__impl__6a9atx(45))) {
                var tmp0_3 = "Unexpected end of string; 'P' designator is required";
                var position_1 = i;
                throw DateTimeFormatException().new_kotlinx_datetime_DateTimeFormatException_hir7ye_k$('Parse error at char ' + position_1 + ': ' + tmp0_3);
              }
              var tmp0_subject = charCodeAt(text, i);
              if (tmp0_subject === _Char___init__impl__6a9atx(43) || tmp0_subject === _Char___init__impl__6a9atx(45)) {
                if (charCodeAt(text, i) === _Char___init__impl__6a9atx(45))
                  sign = -1;
                if (!(charCodeAt(text, i + 1 | 0) === _Char___init__impl__6a9atx(80))) {
                  var tmp0_4 = "Expected 'P', got '" + toString(charCodeAt(text, i + 1 | 0)) + "'";
                  var position_2 = i + 1 | 0;
                  throw DateTimeFormatException().new_kotlinx_datetime_DateTimeFormatException_hir7ye_k$('Parse error at char ' + position_2 + ': ' + tmp0_4);
                }
                i = i + 2 | 0;
              } else if (tmp0_subject === _Char___init__impl__6a9atx(80)) {
                i = i + 1 | 0;
              } else {
                var tmp0_5 = "Expected '+', '-', 'P', got '" + toString(charCodeAt(text, i)) + "'";
                var position_3 = i;
                throw DateTimeFormatException().new_kotlinx_datetime_DateTimeFormatException_hir7ye_k$('Parse error at char ' + position_3 + ': ' + tmp0_5);
              }
              state = AFTER_P;
              continue $l$loop_0;
            }
            var localSign = sign;
            var iStart = i;
            var tmp1_subject = charCodeAt(text, i);
            if (tmp1_subject === _Char___init__impl__6a9atx(43) || tmp1_subject === _Char___init__impl__6a9atx(45)) {
              if (charCodeAt(text, i) === _Char___init__impl__6a9atx(45))
                localSign = imul(localSign, -1);
              i = i + 1 | 0;
              var tmp_0;
              if (i >= text.length) {
                tmp_0 = true;
              } else {
                var containsArg = charCodeAt(text, i);
                tmp_0 = !(_Char___init__impl__6a9atx(48) <= containsArg ? containsArg <= _Char___init__impl__6a9atx(57) : false);
              }
              if (tmp_0) {
                var tmp0_6 = "A number expected after '" + toString(charCodeAt(text, i)) + "'";
                var position_4 = i;
                throw DateTimeFormatException().new_kotlinx_datetime_DateTimeFormatException_hir7ye_k$('Parse error at char ' + position_4 + ': ' + tmp0_6);
              }
            } else if (!(_Char___init__impl__6a9atx(48) <= tmp1_subject ? tmp1_subject <= _Char___init__impl__6a9atx(57) : false))
              if (tmp1_subject === _Char___init__impl__6a9atx(84)) {
                if (state >= AFTER_T) {
                  var tmp0_7 = "Only one 'T' designator is allowed";
                  var position_5 = i;
                  throw DateTimeFormatException().new_kotlinx_datetime_DateTimeFormatException_hir7ye_k$('Parse error at char ' + position_5 + ': ' + tmp0_7);
                }
                state = AFTER_T;
                i = i + 1 | 0;
                continue $l$loop_0;
              }
            var number = 0n;
            $l$loop_1: while (true) {
              var tmp_1;
              if (i < text.length) {
                var containsArg_0 = charCodeAt(text, i);
                tmp_1 = _Char___init__impl__6a9atx(48) <= containsArg_0 ? containsArg_0 <= _Char___init__impl__6a9atx(57) : false;
              } else {
                tmp_1 = false;
              }
              if (!tmp_1) {
                break $l$loop_1;
              }
              try {
                number = safeAdd(safeMultiply(number, 10n), fromInt(Char__minus_impl_a2frrh(charCodeAt(text, i), _Char___init__impl__6a9atx(48))));
              } catch ($p) {
                if ($p instanceof ArithmeticException()) {
                  var _unused_var__etf5q3 = $p;
                  var message_1 = 'The number is too large';
                  throw DateTimeFormatException().new_kotlinx_datetime_DateTimeFormatException_hir7ye_k$('Parse error at char ' + iStart + ': ' + message_1);
                } else {
                  throw $p;
                }
              }
              i = i + 1 | 0;
            }
            someComponentParsed = true;
            var tmp0_8 = number;
            // Inline function 'kotlin.Long.times' call
            var other_0 = localSign;
            number = multiply(tmp0_8, fromInt(other_0));
            if (i === text.length) {
              var tmp0_9 = 'Expected a designator after the numerical value';
              var position_6 = i;
              throw DateTimeFormatException().new_kotlinx_datetime_DateTimeFormatException_hir7ye_k$('Parse error at char ' + position_6 + ': ' + tmp0_9);
            }
            var wrongOrder = "Wrong component order: should be 'Y', 'M', 'W', 'D', then designator 'T', then 'H', 'M', 'S'";
            var tmp2_subject = uppercaseChar(charCodeAt(text, i));
            if (tmp2_subject === _Char___init__impl__6a9atx(89)) {
              if (state >= AFTER_YEAR) {
                var position_7 = i;
                throw DateTimeFormatException().new_kotlinx_datetime_DateTimeFormatException_hir7ye_k$('Parse error at char ' + position_7 + ': ' + wrongOrder);
              }
              state = AFTER_YEAR;
              var tmp2_0 = number;
              // Inline function 'kotlinx.datetime.Companion.toIntThrowing' call
              var component = _Char___init__impl__6a9atx(89);
              if (tmp2_0 < -2147483648n || tmp2_0 > 2147483647n) {
                var message_2 = 'Value ' + tmp2_0.toString() + " does not fit into an Int, which is required for component '" + toString(component) + "'";
                throw DateTimeFormatException().new_kotlinx_datetime_DateTimeFormatException_hir7ye_k$('Parse error at char ' + iStart + ': ' + message_2);
              }
              years = convertToInt(tmp2_0);
            } else if (tmp2_subject === _Char___init__impl__6a9atx(77)) {
              if (state >= AFTER_T) {
                if (state >= AFTER_MINUTE) {
                  var position_8 = i;
                  throw DateTimeFormatException().new_kotlinx_datetime_DateTimeFormatException_hir7ye_k$('Parse error at char ' + position_8 + ': ' + wrongOrder);
                }
                state = AFTER_MINUTE;
                var tmp2_1 = number;
                // Inline function 'kotlinx.datetime.Companion.toIntThrowing' call
                var component_0 = _Char___init__impl__6a9atx(77);
                if (tmp2_1 < -2147483648n || tmp2_1 > 2147483647n) {
                  var message_3 = 'Value ' + tmp2_1.toString() + " does not fit into an Int, which is required for component '" + toString(component_0) + "'";
                  throw DateTimeFormatException().new_kotlinx_datetime_DateTimeFormatException_hir7ye_k$('Parse error at char ' + iStart + ': ' + message_3);
                }
                minutes = convertToInt(tmp2_1);
              } else {
                if (state >= AFTER_MONTH) {
                  var position_9 = i;
                  throw DateTimeFormatException().new_kotlinx_datetime_DateTimeFormatException_hir7ye_k$('Parse error at char ' + position_9 + ': ' + wrongOrder);
                }
                state = AFTER_MONTH;
                var tmp2_2 = number;
                // Inline function 'kotlinx.datetime.Companion.toIntThrowing' call
                var component_1 = _Char___init__impl__6a9atx(77);
                if (tmp2_2 < -2147483648n || tmp2_2 > 2147483647n) {
                  var message_4 = 'Value ' + tmp2_2.toString() + " does not fit into an Int, which is required for component '" + toString(component_1) + "'";
                  throw DateTimeFormatException().new_kotlinx_datetime_DateTimeFormatException_hir7ye_k$('Parse error at char ' + iStart + ': ' + message_4);
                }
                months = convertToInt(tmp2_2);
              }
            } else if (tmp2_subject === _Char___init__impl__6a9atx(87)) {
              if (state >= AFTER_WEEK) {
                var position_10 = i;
                throw DateTimeFormatException().new_kotlinx_datetime_DateTimeFormatException_hir7ye_k$('Parse error at char ' + position_10 + ': ' + wrongOrder);
              }
              state = AFTER_WEEK;
              var tmp2_3 = number;
              // Inline function 'kotlinx.datetime.Companion.toIntThrowing' call
              var component_2 = _Char___init__impl__6a9atx(87);
              if (tmp2_3 < -2147483648n || tmp2_3 > 2147483647n) {
                var message_5 = 'Value ' + tmp2_3.toString() + " does not fit into an Int, which is required for component '" + toString(component_2) + "'";
                throw DateTimeFormatException().new_kotlinx_datetime_DateTimeFormatException_hir7ye_k$('Parse error at char ' + iStart + ': ' + message_5);
              }
              weeks = convertToInt(tmp2_3);
            } else if (tmp2_subject === _Char___init__impl__6a9atx(68)) {
              if (state >= AFTER_DAY) {
                var position_11 = i;
                throw DateTimeFormatException().new_kotlinx_datetime_DateTimeFormatException_hir7ye_k$('Parse error at char ' + position_11 + ': ' + wrongOrder);
              }
              state = AFTER_DAY;
              var tmp2_4 = number;
              // Inline function 'kotlinx.datetime.Companion.toIntThrowing' call
              var component_3 = _Char___init__impl__6a9atx(68);
              if (tmp2_4 < -2147483648n || tmp2_4 > 2147483647n) {
                var message_6 = 'Value ' + tmp2_4.toString() + " does not fit into an Int, which is required for component '" + toString(component_3) + "'";
                throw DateTimeFormatException().new_kotlinx_datetime_DateTimeFormatException_hir7ye_k$('Parse error at char ' + iStart + ': ' + message_6);
              }
              days = convertToInt(tmp2_4);
            } else if (tmp2_subject === _Char___init__impl__6a9atx(72)) {
              if (state >= AFTER_HOUR || state < AFTER_T) {
                var position_12 = i;
                throw DateTimeFormatException().new_kotlinx_datetime_DateTimeFormatException_hir7ye_k$('Parse error at char ' + position_12 + ': ' + wrongOrder);
              }
              state = AFTER_HOUR;
              var tmp2_5 = number;
              // Inline function 'kotlinx.datetime.Companion.toIntThrowing' call
              var component_4 = _Char___init__impl__6a9atx(72);
              if (tmp2_5 < -2147483648n || tmp2_5 > 2147483647n) {
                var message_7 = 'Value ' + tmp2_5.toString() + " does not fit into an Int, which is required for component '" + toString(component_4) + "'";
                throw DateTimeFormatException().new_kotlinx_datetime_DateTimeFormatException_hir7ye_k$('Parse error at char ' + iStart + ': ' + message_7);
              }
              hours = convertToInt(tmp2_5);
            } else if (tmp2_subject === _Char___init__impl__6a9atx(83)) {
              if (state >= AFTER_SECOND_AND_NANO || state < AFTER_T) {
                var position_13 = i;
                throw DateTimeFormatException().new_kotlinx_datetime_DateTimeFormatException_hir7ye_k$('Parse error at char ' + position_13 + ': ' + wrongOrder);
              }
              state = AFTER_SECOND_AND_NANO;
              var tmp2_6 = number;
              // Inline function 'kotlinx.datetime.Companion.toIntThrowing' call
              var component_5 = _Char___init__impl__6a9atx(83);
              if (tmp2_6 < -2147483648n || tmp2_6 > 2147483647n) {
                var message_8 = 'Value ' + tmp2_6.toString() + " does not fit into an Int, which is required for component '" + toString(component_5) + "'";
                throw DateTimeFormatException().new_kotlinx_datetime_DateTimeFormatException_hir7ye_k$('Parse error at char ' + iStart + ': ' + message_8);
              }
              seconds = convertToInt(tmp2_6);
            } else if (tmp2_subject === _Char___init__impl__6a9atx(46) || tmp2_subject === _Char___init__impl__6a9atx(44)) {
              i = i + 1 | 0;
              if (i >= text.length) {
                var tmp0_10 = "Expected designator 'S' after " + toString(charCodeAt(text, i - 1 | 0));
                var position_14 = i;
                throw DateTimeFormatException().new_kotlinx_datetime_DateTimeFormatException_hir7ye_k$('Parse error at char ' + position_14 + ': ' + tmp0_10);
              }
              var iStartFraction = i;
              $l$loop_2: while (true) {
                var tmp_2;
                if (i < text.length) {
                  var containsArg_1 = charCodeAt(text, i);
                  tmp_2 = _Char___init__impl__6a9atx(48) <= containsArg_1 ? containsArg_1 <= _Char___init__impl__6a9atx(57) : false;
                } else {
                  tmp_2 = false;
                }
                if (!tmp_2) {
                  break $l$loop_2;
                }
                i = i + 1 | 0;
              }
              var fractionLength = i - iStartFraction | 0;
              if (fractionLength > 9) {
                var message_9 = 'Only the nanosecond fractions of a second are supported';
                throw DateTimeFormatException().new_kotlinx_datetime_DateTimeFormatException_hir7ye_k$('Parse error at char ' + iStartFraction + ': ' + message_9);
              }
              var fractionalPart = substring(text, iStartFraction, i) + repeat('0', 9 - fractionLength | 0);
              nanoseconds = imul(toInt(fractionalPart, 10), localSign);
              if (!(charCodeAt(text, i) === _Char___init__impl__6a9atx(83))) {
                var tmp0_11 = "Expected the 'S' designator after a fraction";
                var position_15 = i;
                throw DateTimeFormatException().new_kotlinx_datetime_DateTimeFormatException_hir7ye_k$('Parse error at char ' + position_15 + ': ' + tmp0_11);
              }
              if (state >= AFTER_SECOND_AND_NANO || state < AFTER_T) {
                var position_16 = i;
                throw DateTimeFormatException().new_kotlinx_datetime_DateTimeFormatException_hir7ye_k$('Parse error at char ' + position_16 + ': ' + wrongOrder);
              }
              state = AFTER_SECOND_AND_NANO;
              var tmp2_7 = number;
              // Inline function 'kotlinx.datetime.Companion.toIntThrowing' call
              var component_6 = _Char___init__impl__6a9atx(83);
              if (tmp2_7 < -2147483648n || tmp2_7 > 2147483647n) {
                var message_10 = 'Value ' + tmp2_7.toString() + " does not fit into an Int, which is required for component '" + toString(component_6) + "'";
                throw DateTimeFormatException().new_kotlinx_datetime_DateTimeFormatException_hir7ye_k$('Parse error at char ' + iStart + ': ' + message_10);
              }
              seconds = convertToInt(tmp2_7);
            } else {
              var tmp0_12 = 'Expected a designator after the numerical value';
              var position_17 = i;
              throw DateTimeFormatException().new_kotlinx_datetime_DateTimeFormatException_hir7ye_k$('Parse error at char ' + position_17 + ': ' + tmp0_12);
            }
            i = i + 1 | 0;
          }
        }
        return tmp$ret$0;
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
var DateTimePeriodClass;
function DateTimePeriod() {
  if (DateTimePeriodClass === VOID) {
    class $ {
      static new_kotlinx_datetime_DateTimePeriod_hjog9l_k$() {
        return createThis(this);
      }
      get_years_j1r3xp_k$() {
        // Inline function 'kotlin.Long.div' call
        var this_0 = this.get_totalMonths_xmlea9_k$();
        var tmp$ret$0 = divide(this_0, fromInt(12));
        return convertToInt(tmp$ret$0);
      }
      get_months_gqmrjw_k$() {
        // Inline function 'kotlin.Long.rem' call
        var this_0 = this.get_totalMonths_xmlea9_k$();
        var tmp$ret$0 = modulo(this_0, fromInt(12));
        return convertToInt(tmp$ret$0);
      }
      get_hours_islejq_k$() {
        return convertToInt(divide(this.get_totalNanoseconds_kpeleb_k$(), 3600000000000n));
      }
      get_minutes_ivkhkm_k$() {
        return convertToInt(divide(modulo(this.get_totalNanoseconds_kpeleb_k$(), 3600000000000n), 60000000000n));
      }
      get_seconds_xuhyfq_k$() {
        var tmp0 = modulo(this.get_totalNanoseconds_kpeleb_k$(), 60000000000n);
        // Inline function 'kotlin.Long.div' call
        var other = 1000000000;
        var tmp$ret$0 = divide(tmp0, fromInt(other));
        return convertToInt(tmp$ret$0);
      }
      get_nanoseconds_3zfxge_k$() {
        var tmp0 = this.get_totalNanoseconds_kpeleb_k$();
        // Inline function 'kotlin.Long.rem' call
        var other = 1000000000;
        var tmp$ret$0 = modulo(tmp0, fromInt(other));
        return convertToInt(tmp$ret$0);
      }
      toString() {
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
        var tmp;
        if (allNonpositive(this)) {
          this_0.append_58al37_k$(_Char___init__impl__6a9atx(45));
          tmp = -1;
        } else {
          tmp = 1;
        }
        var sign = tmp;
        this_0.append_58al37_k$(_Char___init__impl__6a9atx(80));
        if (!(this.get_years_j1r3xp_k$() === 0)) {
          this_0.append_uppzia_k$(imul(this.get_years_j1r3xp_k$(), sign)).append_58al37_k$(_Char___init__impl__6a9atx(89));
        }
        if (!(this.get_months_gqmrjw_k$() === 0)) {
          this_0.append_uppzia_k$(imul(this.get_months_gqmrjw_k$(), sign)).append_58al37_k$(_Char___init__impl__6a9atx(77));
        }
        if (!(this.get_days_wokl28_k$() === 0)) {
          this_0.append_uppzia_k$(imul(this.get_days_wokl28_k$(), sign)).append_58al37_k$(_Char___init__impl__6a9atx(68));
        }
        var t = 'T';
        if (!(this.get_hours_islejq_k$() === 0)) {
          // Inline function 'kotlin.also' call
          this_0.append_22ad7x_k$(t).append_uppzia_k$(imul(this.get_hours_islejq_k$(), sign)).append_58al37_k$(_Char___init__impl__6a9atx(72));
          t = '';
        }
        if (!(this.get_minutes_ivkhkm_k$() === 0)) {
          // Inline function 'kotlin.also' call
          this_0.append_22ad7x_k$(t).append_uppzia_k$(imul(this.get_minutes_ivkhkm_k$(), sign)).append_58al37_k$(_Char___init__impl__6a9atx(77));
          t = '';
        }
        if (!((this.get_seconds_xuhyfq_k$() | this.get_nanoseconds_3zfxge_k$()) === 0)) {
          this_0.append_22ad7x_k$(t);
          this_0.append_t8pm91_k$(!(this.get_seconds_xuhyfq_k$() === 0) ? imul(this.get_seconds_xuhyfq_k$(), sign) : imul(this.get_nanoseconds_3zfxge_k$(), sign) < 0 ? '-0' : '0');
          if (!(this.get_nanoseconds_3zfxge_k$() === 0)) {
            var tmp_0 = this_0.append_58al37_k$(_Char___init__impl__6a9atx(46));
            // Inline function 'kotlin.math.absoluteValue' call
            var this_1 = this.get_nanoseconds_3zfxge_k$();
            var tmp$ret$7 = abs(this_1);
            tmp_0.append_22ad7x_k$(padStart(tmp$ret$7.toString(), 9, _Char___init__impl__6a9atx(48)));
          }
          this_0.append_58al37_k$(_Char___init__impl__6a9atx(83));
        }
        if (this_0.get_length_g42xv3_k$() === 1) {
          this_0.append_22ad7x_k$('0D');
        }
        return this_0.toString();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DateTimePeriod()))
          return false;
        if (!(this.get_totalMonths_xmlea9_k$() === other.get_totalMonths_xmlea9_k$()))
          return false;
        if (!(this.get_days_wokl28_k$() === other.get_days_wokl28_k$()))
          return false;
        if (!(this.get_totalNanoseconds_kpeleb_k$() === other.get_totalNanoseconds_kpeleb_k$()))
          return false;
        return true;
      }
      hashCode() {
        var result = getBigIntHashCode(this.get_totalMonths_xmlea9_k$());
        result = imul(31, result) + this.get_days_wokl28_k$() | 0;
        result = imul(31, result) + getBigIntHashCode(this.get_totalNanoseconds_kpeleb_k$()) | 0;
        return result;
      }
    }
    initMetadataForClass($, 'DateTimePeriod', VOID, VOID, VOID, VOID, VOID, {0: DateTimePeriodSerializer_getInstance});
    DateTimePeriodClass = $;
  }
  return DateTimePeriodClass;
}
function totalMonths(years, months) {
  // Inline function 'kotlin.Long.times' call
  var this_0 = fromInt(years);
  var tmp$ret$0 = multiply(this_0, fromInt(12));
  // Inline function 'kotlin.also' call
  var this_1 = add(tmp$ret$0, fromInt(months));
  var tmp0 = numberRangeToNumber(-2147483648, 2147483647);
  // Inline function 'kotlin.Long.div' call
  // Inline function 'kotlin.ranges.contains' call
  var value = divide(this_1, fromInt(12));
  // Inline function 'kotlin.require' call
  if (!contains(isInterface(tmp0, ClosedRange()) ? tmp0 : THROW_CCE(), value)) {
    var message = 'The total number of years in ' + years + ' years and ' + months + ' months overflows an Int';
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString_0(message));
  }
  return this_1;
}
function DateTimePeriod_0(years, months, days, hours, minutes, seconds, nanoseconds) {
  years = years === VOID ? 0 : years;
  months = months === VOID ? 0 : months;
  days = days === VOID ? 0 : days;
  hours = hours === VOID ? 0 : hours;
  minutes = minutes === VOID ? 0 : minutes;
  seconds = seconds === VOID ? 0 : seconds;
  nanoseconds = nanoseconds === VOID ? 0n : nanoseconds;
  return buildDateTimePeriod(totalMonths(years, months), days, totalNanoseconds(hours, minutes, seconds, nanoseconds));
}
function buildDateTimePeriod(totalMonths, days, totalNanoseconds) {
  totalMonths = totalMonths === VOID ? 0n : totalMonths;
  days = days === VOID ? 0 : days;
  return !(totalNanoseconds === 0n) ? DateTimePeriodImpl().new_kotlinx_datetime_DateTimePeriodImpl_o3ejzr_k$(totalMonths, days, totalNanoseconds) : DatePeriod().new_kotlinx_datetime_DatePeriod_qtu8pv_k$(totalMonths, days);
}
function totalNanoseconds(hours, minutes, seconds, nanoseconds) {
  // Inline function 'kotlin.Long.times' call
  var this_0 = fromInt(hours);
  // Inline function 'kotlin.Long.plus' call
  var this_1 = multiply(this_0, fromInt(60));
  var totalMinutes = add(this_1, fromInt(minutes));
  // Inline function 'kotlin.Long.times' call
  var totalMinutesAsSeconds = multiply(totalMinutes, fromInt(60));
  // Inline function 'kotlin.Long.div' call
  var other = 1000000000;
  var tmp$ret$3 = divide(nanoseconds, fromInt(other));
  var minutesAndNanosecondsAsSeconds = add(totalMinutesAsSeconds, tmp$ret$3);
  // Inline function 'kotlin.Long.plus' call
  var totalSeconds = add(minutesAndNanosecondsAsSeconds, fromInt(seconds));
  var tmp;
  try {
    // Inline function 'kotlin.Long.rem' call
    var other_0 = 1000000000;
    var tmp$ret$5 = modulo(nanoseconds, fromInt(other_0));
    tmp = multiplyAndAdd(totalSeconds, 1000000000n, tmp$ret$5);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof ArithmeticException()) {
      var _unused_var__etf5q3 = $p;
      throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('The total number of nanoseconds in ' + hours + ' hours, ' + minutes + ' minutes, ' + seconds + ' seconds, and ' + nanoseconds.toString() + ' nanoseconds overflows a Long');
    } else {
      throw $p;
    }
  }
  return tmp;
}
var DateTimePeriodImplClass;
function DateTimePeriodImpl() {
  if (DateTimePeriodImplClass === VOID) {
    class $ extends DateTimePeriod() {
      constructor(totalMonths, days, totalNanoseconds) {
        return new.target.new_kotlinx_datetime_DateTimePeriodImpl_o3ejzr_k$(totalMonths, days, totalNanoseconds);
      }
      static new_kotlinx_datetime_DateTimePeriodImpl_o3ejzr_k$(totalMonths, days, totalNanoseconds) {
        var $this = this.new_kotlinx_datetime_DateTimePeriod_hjog9l_k$();
        $this.totalMonths_1 = totalMonths;
        $this.days_1 = days;
        $this.totalNanoseconds_1 = totalNanoseconds;
        return $this;
      }
      get_totalMonths_xmlea9_k$() {
        return this.totalMonths_1;
      }
      get_days_wokl28_k$() {
        return this.days_1;
      }
      get_totalNanoseconds_kpeleb_k$() {
        return this.totalNanoseconds_1;
      }
    }
    initMetadataForClass($, 'DateTimePeriodImpl');
    DateTimePeriodImplClass = $;
  }
  return DateTimePeriodImplClass;
}
//region block: init
Companion_instance = new (Companion())();
Companion_instance_0 = new (Companion_0())();
//endregion
//region block: exports
export {
  Companion_instance_0 as Companion_instance3kamikfo48xfz,
  DatePeriod as DatePeriod2y4m7pf19ebgd,
  DateTimePeriod as DateTimePeriod384alsehm5scz,
};
//endregion

//# sourceMappingURL=DateTimePeriod.mjs.map
